module.exports = __webpack_public_path__ + "static/media/35.cdb9a59f.jpg";